export const NiceToMeetYou = () => {
  return (
    <svg
      width="190"
      height="150"
      viewBox="0 50 190 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{
        position: "absolute",
        top: -60,
        right: -60,
      }}
    >
      <path
        d="M26.1024 99.205L14.7591 84.8803L14.8092 84.8406L34.1302 92.8479L36.5887 90.9011L22.6827 73.3403L20.6005 74.9891L31.9438 89.3137L31.8937 89.3535L12.5727 81.3461L10.1393 83.2731L24.0453 100.834L26.1024 99.205Z"
        fill="#F6C042"
      />
      <path
        d="M32.3886 70.5935L31.0126 68.1733L28.5089 69.5967L29.8849 72.0169L32.3886 70.5935ZM42.1028 88.0033L33.7203 73.2596L31.5505 74.4933L39.9329 89.237L42.1028 88.0033Z"
        fill="#F6C042"
      />
      <path
        d="M51.621 84.0481C55.2497 82.6081 57.0116 79.3268 56.2136 75.581L53.7643 76.0022C54.345 78.7669 53.228 80.8971 50.7593 81.8768C47.785 83.0572 44.8243 81.4091 43.3488 77.6912C41.8734 73.9732 42.8983 70.7434 45.8726 69.5631C48.3413 68.5834 50.6151 69.368 52.0881 71.7786L54.1598 70.4056C52.1721 67.132 48.6396 65.9517 45.0109 67.3918C40.6981 69.1033 39.0576 73.6447 41.0288 78.6119C43 83.579 47.3082 85.7597 51.621 84.0481Z"
        fill="#F6C042"
      />
      <path
        d="M67.8785 79.4247C71.0928 78.8571 73.2577 76.9476 74.2009 73.824L71.9356 72.9567C70.9516 75.665 69.7839 76.7811 67.4204 77.1984C64.3322 77.7438 61.8424 75.4213 61.2174 72.2497L73.9169 70.0072L73.6943 68.7467C72.8207 63.7992 69.2687 60.982 64.7624 61.7777C60.1616 62.5901 57.6706 66.7019 58.5999 71.9645C59.5292 77.2271 63.2462 80.2427 67.8785 79.4247ZM60.9298 70.2533C60.4976 67.4375 62.2583 64.527 65.1575 64.0151C68.1197 63.492 70.4537 65.4845 71.0769 68.4615L60.9298 70.2533Z"
        fill="#F6C042"
      />
      <path
        d="M94.0206 61.2378L89.8706 60.9508L90.1355 57.1199L87.6455 56.9477L87.3805 60.7786L84.8266 60.6019L84.672 62.8366L87.2259 63.0132L86.4796 73.8034C86.2809 76.6766 87.2957 77.7732 90.3603 77.9852L91.9565 78.0956L92.1177 75.7651L90.7131 75.668C89.3084 75.5708 88.8924 75.093 88.9675 74.0076L89.716 63.1854L93.8661 63.4725L94.0206 61.2378Z"
        fill="#F6C042"
      />
      <path
        d="M101.588 80.3087C106.266 81.3847 110.195 78.578 111.393 73.37C112.591 68.162 110.283 63.9207 105.605 62.8447C100.927 61.7688 97.0293 64.5826 95.8314 69.7906C94.6335 74.9986 96.9103 79.2327 101.588 80.3087ZM102.112 78.0321C98.8373 77.279 97.36 74.2795 98.2638 70.3501C99.1677 66.4207 101.807 64.3681 105.081 65.1213C108.356 65.8744 109.864 68.8811 108.961 72.8105C108.057 76.7399 105.386 78.7853 102.112 78.0321Z"
        fill="#F6C042"
      />
      <path
        d="M119.699 85.8065L125.617 76.2602C126.831 74.302 128.854 73.7112 130.731 74.8746C132.499 75.9706 133.018 77.9869 131.872 79.8364L125.818 89.6002L127.858 90.8648L133.793 81.2913C134.99 79.3603 137.041 78.7864 138.917 79.9498C140.712 81.0626 141.205 83.0621 140.058 84.9116L134.005 94.6754L136.126 95.9906L142.348 85.9548C144.186 82.9902 143.031 79.7517 140.284 78.0487C138.652 77.037 136.816 76.8402 135.112 77.4027L135.058 77.3689C134.998 75.8258 134.056 74.1875 132.424 73.1758C131.064 72.3328 129.323 72.044 127.971 72.5238L127.917 72.4901L128.608 71.375L126.514 70.0767L117.578 84.4913L119.699 85.8065Z"
        fill="#F6C042"
      />
      <path
        d="M142.252 103.22C144.533 105.554 147.331 106.266 150.442 105.283L149.881 102.923C147.09 103.638 145.51 103.303 143.832 101.586C141.641 99.3432 142.155 95.9774 144.422 93.6729L153.434 102.897L154.35 102.002C157.943 98.491 158.267 93.969 155.069 90.696C151.804 87.3544 147.004 87.6156 143.182 91.3504C139.359 95.0851 138.965 99.8553 142.252 103.22ZM145.909 92.3097C147.99 90.3651 151.387 90.1782 153.444 92.2839C155.546 94.4353 155.217 97.4864 153.11 99.6796L145.909 92.3097Z"
        fill="#F6C042"
      />
      <path
        d="M152.792 116.394C154.564 119.135 157.165 120.387 160.41 120.042L160.328 117.618C157.45 117.764 155.968 117.122 154.665 115.106C152.962 112.473 154.134 109.276 156.813 107.468L163.816 118.297L164.891 117.602C169.109 114.874 170.324 110.506 167.84 106.663C165.303 102.74 160.546 102.043 156.058 104.945C151.571 107.847 150.237 112.444 152.792 116.394ZM158.541 106.427C160.967 104.934 164.333 105.425 165.932 107.897C167.565 110.423 166.637 113.348 164.136 115.079L158.541 106.427Z"
        fill="#F6C042"
      />
      <path
        d="M176.884 125.284L175.221 121.471L178.74 119.935L177.742 117.647L174.223 119.183L173.199 116.837L171.146 117.733L172.169 120.079L162.256 124.405C159.616 125.556 159.113 126.963 160.342 129.779L160.981 131.245L163.122 130.311L162.559 129.02C161.996 127.73 162.228 127.14 163.225 126.705L173.168 122.367L174.831 126.18L176.884 125.284Z"
        fill="#F6C042"
      />
      <path
        d="M157.707 145.504L183.29 151.231L182.819 148.617L169.465 145.79L169.453 145.727L180.978 138.413L180.501 135.768L166.335 145.021L157.247 142.954L157.707 145.504Z"
        fill="#F6C042"
      />
      <path
        d="M166.085 162.732C166.033 167.532 169.614 170.771 174.957 170.829C180.301 170.888 183.952 167.727 184.004 162.928C184.056 158.128 180.475 154.921 175.131 154.862C169.788 154.804 166.137 157.933 166.085 162.732ZM168.421 162.758C168.457 159.398 171.072 157.314 175.104 157.358C179.136 157.402 181.705 159.542 181.668 162.902C181.631 166.262 179.016 168.378 174.984 168.334C170.953 168.29 168.384 166.117 168.421 162.758Z"
        fill="#F6C042"
      />
      <path
        d="M164.48 178.049C164.058 180.053 164.451 182.066 165.454 183.356L165.441 183.419L163.907 183.096L163.405 185.475L180.001 188.973L180.515 186.531L170.089 184.333C167.49 183.785 166.079 181.788 166.614 179.251C167.208 176.433 168.894 175.415 171.837 176.036L182.264 178.233L182.779 175.791L172.008 173.521C168 172.676 165.259 174.355 164.48 178.049Z"
        fill="#F6C042"
      />
      <path
        d="M160.603 192.858L164.078 194.163L165.417 190.598L161.941 189.293L160.603 192.858Z"
        fill="#F6C042"
      />
    </svg>
  )
}
